import React from 'react'
import "./SubStyle.css"

const Soft_Allowances = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Capital allowances</h1>
      <p className="OurServices-pera">Capital allowances are a form of tax relief that allows a business to deduct the cost of certain capital assets from its taxable profits over time. These assets may include machinery, equipment, vehicles, computers, and some building-related expenditures.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Allowances
